import { createDropdownData } from '../../../../../../utils/validators/HelperFunctions';

export const hourlyPricingSelectOptions = (strings: any) =>
  createDropdownData(
    [
      { id: 'true', name: strings.dropdown_yes_text },
      { id: 'false', name: strings.dropdown_no_text },
    ],
    ['id', 'name'],
  );

/** Parse API booleans, SelectedDropDown strings, or react-select option values. */
export const parseBoolFlag = (value: any): boolean => {
  if (value == null || value === '') return false;
  if (typeof value === 'object' && value !== null && 'value' in value) {
    return parseBoolFlag(value.value);
  }
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value !== 0;
  const normalized = String(value).trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'yes';
};

export const toHourlyPricingFormValue = (value: any, strings: any) => {
  const options = hourlyPricingSelectOptions(strings);
  const targetValue = parseBoolFlag(value) ? 'true' : 'false';
  return options.find(o => String(o.value) === targetValue) ?? options.find(o => o.value === 'false');
};

export const isHourlyPricingValue = (value: any): boolean => parseBoolFlag(value);
